import React from "react";
import type { ModeRendererProps } from "./types";

export function VasarelyWhaleMode({ Copy }: ModeRendererProps) {
  return (
    <g>
      <rect width={794} height={1123} fill="#e6f7ff" />
      <ellipse cx={397} cy={640} rx={300} ry={120} fill="#3b6ea5" />
      <rect x={300} y={560} width={194} height={80} fill="#2a5a8a" rx={40} />
      <g className="mode-copy" transform="translate(48,840)" fill="#012"><text x={0} y={0} fontSize={18}>{Copy?.title}</text></g>
    </g>
  );
}

export default VasarelyWhaleMode;
